
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"m493.3 56.2-37.5-37.5c-25-25-65.5-25-90.5 0l-352.5 352.5-12.6 114.1c-1.7 15.3 11.2 28.2 26.5 26.5l114.2-12.7 352.4-352.4c25-25 25-65.5 0-90.5zm-95.2 140.5-224.1 224v-34.7h-48v-48h-34.7l224.1-224.1 82.7 82.7zm-272 271.9-59 6.6-30.3-30.3 6.6-59 19.9-19.9h34.7v48h48v34.7zm344.5-344.5-49.9 49.9-82.7-82.7 49.9-49.9c12.5-12.5 32.7-12.5 45.3 0l37.5 37.5c12.5 12.5 12.5 32.7 0 45.3z"}})])
          )
        }
      }
    